import { render, staticRenderFns } from "./GroupRedactor.vue?vue&type=template&id=ec58fd80&scoped=true"
import script from "./GroupRedactor.vue?vue&type=script&lang=js"
export * from "./GroupRedactor.vue?vue&type=script&lang=js"
import style0 from "./GroupRedactor.vue?vue&type=style&index=0&id=ec58fd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec58fd80",
  null
  
)

export default component.exports